import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-styled-flexboxgrid';
import { Helmet } from 'react-helmet';
import Footer from './Footer';

// STYLES
const Content = styled.div`
  position: absolute;
  left: 0;
  top: 80px;
  width: 100%;
  z-index: -1;
  padding-top: 5rem;

  @media only screen and (min-width: ${props => props.theme.bp.navigation}) {
    top: 0;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  max-width: ${props => props.theme.layout.width.content};
  padding: 0 15px;
  overflow: hidden;
`;

const StyledFooter = styled(Footer)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

// COMPONENT
const Page = props => (
  <React.Fragment>
    <Helmet><title>Sprechbox - { props.title }</title></Helmet>
    <Content>
      <Container>
        <Row center="sm">
          <Col xs={12}>{ props.children }</Col>
        </Row>
      </Container>
      <StyledFooter />
    </Content>
  </React.Fragment>
);

export default Page;